import React, { useState, useEffect, useRef } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
// @mui
import { styled } from '@mui/material/styles';

import axios from 'axios';
import { loadTossPayments } from '@tosspayments/payment-sdk';
import { v4 as uuidv4 } from 'uuid';
import moment from 'moment';
import 'moment/locale/ko';
// component
import FreePlan from './plan_component/FreePlan';
import BasicPlan from './plan_component/BasicPlan';
import ProPlan from './plan_component/ProPlan';

const clientKey = process.env.REACT_APP_TOSSPAYMENT_KEY;

// ----------------------------------------------------------------------

const Div = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  // alignItems:'center',
  flex: 1,
  alignItems: 'stretch',
}));

const ContentDiv = styled('div')(({ theme }) => ({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
}));

const SelectDiv = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
}));

const H2 = styled('h2')(({ theme }) => ({
  fontSize: '2em',
}));

const FlexDiv = styled('div')(({ theme }) => ({
  padding: '80px',
  display: 'flex',
  backgroundColor: 'white',
  border: 'solid 1px #f1f1f1',
  borderRadius: '20px',
}));

const FORM = styled('form')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
}));

const SELECT = styled('select')(({ theme }) => ({
  width: 300,
  height: 60,
  padding: 10,
  marginTop: 30,
  fontSize: 'large',
}));

const ButtonDiv = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
}));

const PreButton = styled('button')(({ theme }) => ({
  width: '160px',
  padding: '15px',
  backgroundColor: 'white',
  border: 'solid 1px #ddd',
  borderRadius: '5px',
  fontSize: 'larger',
  marginRight: 10,
}));

const PayButton = styled('button')(({ theme }) => ({
  width: '-webkit-fill-available',
  padding: '15px',
  backgroundColor: '#1a9ef8',
  border: 'solid 1px #1a9ef8',
  borderRadius: '5px',
  fontSize: 'larger',
  color: 'white',
}));

export default function RegistPayment({ parentFunction }) {
  const { register, handleSubmit } = useForm();
  const onSubmit = (Data) => console.log(Data);
  const navigate = useNavigate();
  // ------------------------------------------------------------------

  const [write, setWrite] = useState(false);
  const [selectPaymentDate, setSelectPaymentDate] = useState('M');
  const [price, setPrice] = useState(2900);
  const [textPrice, setTextPrice] = useState('2,900/월');

  const today = new Date();
  const newDay = new Date();

  const [nextPaymentDate, setNextPaymentDate] = useState(moment().add(1, 'M').format('YYYY-MM-DD'));

  function sendCancel() {
    parentFunction(write);
  }

  const paymentTypeHandleChange = (event) => {
    setSelectPaymentDate(event.target.value);
    if (event.target.value === 'M' && sessionStorage.getItem('select_plan') === 'Basic') {
      setTextPrice('2,900/월');
      setNextPaymentDate(moment().add(1, 'M').format('YYYY-MM-DD'));
      setPrice(2900);
      sessionStorage.setItem('is_subscription', event.target.value);
    } else if (event.target.value === 'Y' && sessionStorage.getItem('select_plan') === 'Basic') {
      setTextPrice('34,800/년');
      setNextPaymentDate(moment().add(1, 'y').format('YYYY-MM-DD'));
      setPrice(34800);
      sessionStorage.setItem('is_subscription', event.target.value);
    } else if (event.target.value === 'M' && sessionStorage.getItem('select_plan') === 'pro') {
      setTextPrice('21,900/월');
      setNextPaymentDate(moment().add(1, 'M').format('YYYY-MM-DD'));
      setPrice(21900);
      sessionStorage.setItem('is_subscription', event.target.value);
    } else if (event.target.value === 'Y' && sessionStorage.getItem('select_plan') === 'pro') {
      setTextPrice('262,800/년');
      setNextPaymentDate(moment().add(1, 'y').format('YYYY-MM-DD'));
      setPrice(262800);
      sessionStorage.setItem('is_subscription', event.target.value);
    } else if (event.target.value === 'M' && sessionStorage.getItem('select_plan') === 'Basic_new') {
      setTextPrice('23,900/월');
      setNextPaymentDate(moment().add(1, 'M').format('YYYY-MM-DD'));
      setPrice(23900);
      sessionStorage.setItem('is_subscription', event.target.value);
    } else if (event.target.value === 'Y' && sessionStorage.getItem('select_plan') === 'Basic_new') {
      setTextPrice('239,000/년');
      setNextPaymentDate(moment().add(1, 'y').format('YYYY-MM-DD'));
      setPrice(239000);
      sessionStorage.setItem('is_subscription', event.target.value);
    } else if (event.target.value === 'M' && sessionStorage.getItem('select_plan') === 'pro_new') {
      setTextPrice('54,900/월');
      setNextPaymentDate(moment().add(1, 'M').format('YYYY-MM-DD'));
      setPrice(54900);
      sessionStorage.setItem('is_subscription', event.target.value);
    } else if (event.target.value === 'Y' && sessionStorage.getItem('select_plan') === 'pro_new') {
      setTextPrice('549,000/년');
      setNextPaymentDate(moment().add(1, 'y').format('YYYY-MM-DD'));
      setPrice(549000);
      sessionStorage.setItem('is_subscription', event.target.value);
    }
  };

  useEffect(() => {
    switch (sessionStorage.getItem('select_plan')) {
      case 'Basic':
        setTextPrice('2,900/월');
        setPrice(2900);
        break;
      case 'pro':
        setTextPrice('21,900/월');
        setPrice(21900);
        break;
      case 'Basic_new':
        setTextPrice('23,900/월');
        setPrice(23900);
        break;
      case 'pro_new':
        setTextPrice('48,900/월');
        setPrice(48900);
        break;
      default:
        break;
    }
  }, []);

  // --------------------------------------------------------------------
  async function registLicense() {
    console.log(sessionStorage.getItem('is_subscription'));

    let licenseType = '';
    switch (sessionStorage.getItem('select_plan')) {
      case 'free':
        licenseType = 'raindrop_free';
        break;
      case 'Basic':
        licenseType = 'raindrop_basic';
        break;
      case 'pro':
        licenseType = 'raindrop_pro';
        break;
      case 'Basic_new':
        licenseType = 'raindrop_basic_new';
        break;
      case 'pro_new':
        licenseType = 'raindrop_pro_new';
        break;

      default:
        break;
    }

    const sendData = {
      user_token: JSON.parse(sessionStorage.getItem('login_info')).user_token,
      license_type: licenseType,
      type: 'raindrop',
    };

    // console.log('조직 등록 보낼 데이터 : ', sendData)
    // console.log('조직 등록 보낼 데이터 : ', sendData.license_type)

    switch (sendData.license_type) {
      case 'raindrop_basic':
        loadTossPayments(clientKey).then((tossPayments) => {
          // 카드 결제 메서드 실행
          tossPayments.requestBillingAuth(`카드`, {
            customerKey: JSON.parse(sessionStorage.getItem('login_info')).user_token,
            amount: price, // 가격
            orderId: uuidv4(), // 주문 id
            orderName: `rdbasic`, // 결제 이름
            customerName: `Sugarpole`, // 판매자, 판매처 이름
            successUrl: `${window.location.origin}/success`, // 성공시 리다이렉트 주소
            failUrl: `${window.location.origin}/failed`, // 실패시 리다이렉트 주소
          });
        });
        break;

      case 'raindrop_pro':
        // alert('프로 플랜 결제 등록 필요')
        loadTossPayments(clientKey).then((tossPayments) => {
          // 카드 결제 메서드 실행
          tossPayments.requestBillingAuth(`카드`, {
            customerKey: JSON.parse(sessionStorage.getItem('login_info')).user_token,
            amount: price, // 가격
            orderId: uuidv4(), // 주문 id
            orderName: `rdpro`, // 결제 이름
            customerName: `Sugarpole`, // 판매자, 판매처 이름
            successUrl: `${window.location.origin}/success`, // 성공시 리다이렉트 주소
            failUrl: `${window.location.origin}/failed`, // 실패시 리다이렉트 주소
          });
        });
        break;

      case 'raindrop_basic_new':
        loadTossPayments(clientKey).then((tossPayments) => {
          // 카드 결제 메서드 실행
          tossPayments.requestBillingAuth(`카드`, {
            customerKey: JSON.parse(sessionStorage.getItem('login_info')).user_token,
            amount: price, // 가격
            orderId: uuidv4(), // 주문 id
            orderName: `rdbasic_new`, // 결제 이름
            customerName: `Sugarpole`, // 판매자, 판매처 이름
            successUrl: `${window.location.origin}/success`, // 성공시 리다이렉트 주소
            failUrl: `${window.location.origin}/failed`, // 실패시 리다이렉트 주소
          });
        });
        break;

      case 'raindrop_pro_new':
        // alert('프로 플랜 결제 등록 필요')
        loadTossPayments(clientKey).then((tossPayments) => {
          // 카드 결제 메서드 실행
          tossPayments.requestBillingAuth(`카드`, {
            customerKey: JSON.parse(sessionStorage.getItem('login_info')).user_token,
            amount: price, // 가격
            orderId: uuidv4(), // 주문 id
            orderName: `rdpro_new`, // 결제 이름
            customerName: `Sugarpole`, // 판매자, 판매처 이름
            successUrl: `$${window.location.origin}/success`, // 성공시 리다이렉트 주소
            failUrl: `$${window.location.origin}/failed`, // 실패시 리다이렉트 주소
          });
        });
        break;

      default:
        axios({
          url: `${process.env.REACT_APP_SERVER_URL}/user/license`,
          method: 'post',
          data: sendData,
        })
          .then((response) => {
            axios
              .post(`${process.env.REACT_APP_SERVER_URL}/user/org`, {
                org_name: sessionStorage.getItem('org_name'),
                org_create_user_token: JSON.parse(sessionStorage.getItem('login_info')).user_token,
              })
              .then((response) => {
                console.log('sucess', response);
                alert('프리 플랜 등록이 완료되었습니다.');
                navigate('/mypage', { replace: true });
              })
              .catch((response) => {
                console.log('그룹 중복 axios 에러 응답', response);
              });
          })
          .catch((error) => {
            console.log('라이센스 등록 오류', error);
          });
        break;
    }
  }

  return (
    <>
      <Div>
        <ContentDiv>
          <H2>
            {' '}
            그룹의 결제를 진행합니다.
            <br />
            결제 정보를 확인해주세요.
          </H2>
          {sessionStorage.getItem('select_plan') === 'Basic' ? (
            <BasicPlan data={JSON.parse(sessionStorage.getItem('login_info')).login_id} />
          ) : sessionStorage.getItem('select_plan') === 'pro' ? (
            <ProPlan data={JSON.parse(sessionStorage.getItem('login_info')).login_id} />
          ) : sessionStorage.getItem('select_plan') === 'free' ? (
            <FreePlan data={JSON.parse(sessionStorage.getItem('login_info')).login_id} />
          ) : sessionStorage.getItem('select_plan') === 'Basic_new' ? (
            <BasicPlan data={JSON.parse(sessionStorage.getItem('login_info')).login_id} />
          ) : sessionStorage.getItem('select_plan') === 'pro_new' ? (
            <ProPlan data={JSON.parse(sessionStorage.getItem('login_info')).login_id} />
          ) : null}
        </ContentDiv>

        <FlexDiv>
          <FORM name="user_post" onSubmit={handleSubmit(onSubmit)}>
            <H2>결제 정보</H2>
            <div>
              <p style={{ fontSize: 'x-large', fontWeight: '700', width: 600 }}>
                {sessionStorage.getItem('select_plan') === 'Basic'
                  ? '베이직 플랜(Basic Plan)'
                  : sessionStorage.getItem('select_plan') === 'pro'
                  ? '프로 플랜(Pro Plan)'
                  : sessionStorage.getItem('select_plan') === 'free'
                  ? '프리 플랜(Free Plan)'
                  : sessionStorage.getItem('select_plan') === 'Basic_new'
                  ? '베이직 플랜(Basic Plan)'
                  : sessionStorage.getItem('select_plan') === 'pro_new'
                  ? '프로 플랜(Pro Plan)'
                  : null}
              </p>
              <SelectDiv>
                <SELECT {...register('selection')} onChange={paymentTypeHandleChange}>
                  <option value="M">월간 구독</option>
                  <option value="Y">연간 구독</option>
                </SELECT>
                <p style={{ fontSize: 'x-large', fontWeight: '700', marginTop: '30px' }}>
                  {sessionStorage.getItem('select_plan') === 'free' ? '무료' : `${textPrice}`}
                </p>
              </SelectDiv>
            </div>
            <div>
              <SelectDiv>
                <p>다음 자동 결제일 {nextPaymentDate}</p>
                <p>{sessionStorage.getItem('select_plan') === 'free' ? '무료' : `${textPrice}`}</p>
              </SelectDiv>
            </div>
            <ButtonDiv>
              <PreButton
                onClick={() => {
                  sendCancel();
                }}
              >
                이전
              </PreButton>
              <PayButton
                onClick={() => {
                  registLicense();
                }}
              >
                구독하기
              </PayButton>
            </ButtonDiv>
          </FORM>
        </FlexDiv>
      </Div>
      <div id="payment-widget" />
    </>
  );
}
